module.exports = __webpack_public_path__ + "img/invoices_report.8c61e1c6.png";